import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'nns-breadcumbs',
  styles: [`
    :host {
      display:block;
      font-size:18px;
    }
    .nns-breadcrumbs-link {
      margin:0 16px 0 0;
    }
    .nns-breadcrumbs-link nns-icon {
      margin: 0 8px 0 0;
      min-height: 16px;
    }
    .nns-breadcrumbs-link-text {
      margin:0 0 0 8px;
    }
    .nns-breadcrumbs-inner-text {
      white-space:nowrap;
      text-overflow:ellipsis;
      overflow:hidden;
      display:block;
      max-width:100%;
      font-size:13px;
      color:#323232;
      font-weight:bold;
    }
    .nns-breadcrumbs-separator {
      width:1px;
      background: rgba(0,0,0,0.12);
      height:32px;
      margin:0 16px 0 0;
    }
    .nns-breadcrumbs-current {
      font-size:21px;
      color:rgba(0,0,0, 0.8);
      font-weight:bold;
      margin:0 24px 0 0;
    }
    .nns-breadcrumbs-prev{
      width: 16px;
      height: 16px;
      flex: 0 0 16px;
      border-radius: 50%;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #C4C4C4;
    }
    .nns-breadcrumbs-prev svg{
      margin-right: 1px;
    }
  `, `
    :host-context(.nns-theme-night) .nns-breadcrumbs-current {
     color:rgba(255,255,255, 0.8);
    }
    :host-context(.nns-theme-night) .nns-breadcrumbs-separator {
      background:#9EA5A6;
    }
    :host-context(.nns-theme-night) .nns-breadcrumbs-prev {
      color: #2F3737;
    }
    :host-context(.nns-theme-night) .nns-breadcrumbs-inner-text {
      color: #fff;
    }
  `],
  template: `
    <div class="nns-breadcrumbs-layout" flex layout="row" layout-align="start center">
      <a class="nns-breadcrumbs-link" [routerLink]="backUrl" [queryParams]="backQueryParams"
        title="{{ share?.parent?.title | unescape }}"
        flex="auto" layout="row" layout-align="center center"
        *ngIf="backUrl && !visual.isHeaderFixed"
      >
        <div class="nns-breadcrumbs-prev">
          <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4C0 3.87204 0.0542393 3.74408 0.162718 3.64645L4.05161 0.146447C4.26857 -0.0488155 4.62032 -0.0488155 4.83728 0.146447C5.05424 0.341709 5.05424 0.658291 4.83728 0.853553L1.34123 4L4.83728 7.14645C5.05424 7.34171 5.05424 7.65829 4.83728 7.85355C4.62032 8.04882 4.26857 8.04882 4.05161 7.85355L0.162718 4.35355C0.0542393 4.25592 0 4.12796 0 4Z" fill="currentColor"/>
          </svg>
        </div>
        <span class="nns-breadcrumbs-link-text" flex="auto">
          <span class="nns-breadcrumbs-inner-text" [innerHTML]="share?.parent?.title"></span>
        </span>
      </a>

      <!--<div
        class="nns-breadcrumbs-separator"
        flex="none"
        *ngIf="share?.parent && isShowTitle && !visual.isHeaderFixed"
      ></div>-->

      <div
        class="nns-breadcrumbs-current {{visual.noteFont ? 'font-' + visual.noteFont : ''}}"
        flex="auto"
        *ngIf="isShowTitle"
        >
        <span class="nns-breadcrumbs-inner-text" [innerHTML]="note?.title"></span>
      </div>

    </div>
  `
})
export class BreadcumbsComponent implements OnChanges {
  @Input() public note;
  @Input() public share;
  @Input() public visual;

  isShowTitle = false;
  backUrl: string;
  backQueryParams;

  ngOnChanges(changes) {
    if (!this.share || !this.note || !this.visual) {
      return;
    }
    this.isShowTitle = this.visual.isHeaderFixed;
    if(changes.share) {
      if (this.share.parent) {
        if (this.share.parent.share) {
          const { id, securityKey, noteGlobalId } = this.share.parent.share;
          this.backUrl = `/share/${id}/${securityKey}/${noteGlobalId}`;
        } else {
          this.backUrl = this.share.parent.nnShareUrl
        }
      } else {
        this.backUrl = null;
      }
    }
    if(this.visual && this.visual.isEmbed) {
      this.backQueryParams = {embed: true};
    }
  }
}
